// frontend/src/pages/SuccessPage.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
 
export default function SuccessPage() {
  const navigate = useNavigate();
 
  useEffect(() => {
    // Redirect to dashboard after 3 seconds
    const timer = setTimeout(() => navigate('/'), 3000);
    return () => clearTimeout(timer);
  }, [navigate]);
 
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',
                  justifyContent: 'center', minHeight: '100vh', textAlign: 'center' }}>
      <div style={{ fontSize: '80px' }}>🎉</div>
      <h1 style={{ color: '#1A6B3A' }}>Payment Successful!</h1>
      <p style={{ color: '#555', fontSize: '18px' }}>
        Your subscription is now active. Redirecting to dashboard...
      </p>
    </div>
  );
}
